import React, { Component } from 'react'
import { observer } from 'mobx-react'
import SearchBar from '@common/SearchBar'
import { Input, DatePicker, Select } from 'hljd'
import { isHotelMerchant } from '@util'

const RangePicker = DatePicker.RangePicker
const Item = SearchBar.Item
const Option = Select.Option

@observer
export default class extends Component {
  render() {
    return (
      <div style={{ padding: 20, marginBottom: 30 }}>
        <SearchBar store={this.props.store} noNeed={['name']}>
          <Item label="优惠券名称" name="name">
            <Input style={{ width: 140 }} placeholder="优惠券名称" />
          </Item>
          <Item label="生效时间" name="date">
            <RangePicker style={{ width: 264 }} />
          </Item>

          {isHotelMerchant() && (
            <Item name="coupon_type">
              <Select style={{ width: 100 }} placeholder="优惠券类型">
                <Option value="1">普通优惠券</Option>
                <Option value="2">特殊专享券</Option>
              </Select>
            </Item>
          )}

          <Item name="is_valid">
            <Select style={{ width: 100 }} placeholder="是否生效">
              <Option value="1">待生效</Option>
              <Option value="2">已生效</Option>
              <Option value="3">已过期</Option>
            </Select>
          </Item>
          <Item name="hidden">
            <Select style={{ width: 100 }} placeholder="是否激活">
              <Option value="0">未激活</Option>
              <Option value="1">已激活</Option>
            </Select>
          </Item>
        </SearchBar>
      </div>
    )
  }
}
